/* eslint-disable */
/* this file is generated by generateIcons script */

import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AndroidIcon extends BaseIcon {
  getChildren = () => [
    <g fill='#A4C639'>
      <g>
        <g>
          <path
            d="M17.7,30.8c1.5,0,2.7,1.2,2.7,2.7l0,11.6c0,1.4-0.9,2.6-2.2,2.9c-1.7,0.3-3.2-1-3.2-2.7V33.5 C14.9,32,16.2,30.8,17.7,30.8L17.7,30.8z"/>
        </g>
        <g>
          <path d="M11.3,15c0,0.1,0,0.2,0,0.3v18.8c0,2,1.6,3.7,3.6,3.7h19.2c2,0,3.6-1.6,3.6-3.7V15c0,0,0,0,0,0L11.3,15 L11.3,15z"/>
        </g>
        <g>
          <path d="M12.3,1.9l3.1,5.4 M36.7,1.9l-3.1,5.4"/>
          <path
            d="M33.6,8.2c-0.2,0-0.3,0-0.5-0.1c-0.4-0.3-0.6-0.8-0.3-1.2l3.1-5.4c0.3-0.4,0.8-0.6,1.2-0.3 c0.4,0.3,0.6,0.8,0.3,1.2l-3.1,5.4C34.2,8,33.9,8.2,33.6,8.2z M15.4,8.2c-0.3,0-0.6-0.2-0.8-0.5l-3.1-5.4c-0.3-0.4-0.1-1,0.3-1.2 c0.4-0.3,1-0.1,1.2,0.3l3.1,5.4c0.3,0.4,0.1,1-0.3,1.2C15.7,8.1,15.6,8.2,15.4,8.2z"/>
        </g>
        <g>
          <path d="M6.7,17.3c-1.5,0-2.7,1.2-2.7,2.7v11.7c0,1.6,1.3,2.8,2.9,2.7c1.5-0.1,2.6-1.4,2.6-2.9V20.1 C9.5,18.6,8.2,17.3,6.7,17.3z"/>
          <path d="M31.3,30.8L31.3,30.8c-1.5,0-2.7,1.2-2.7,2.7v11.7c0,1.7,1.5,3,3.2,2.7c1.3-0.2,2.2-1.5,2.2-2.9V33.5 C34.1,32,32.8,30.8,31.3,30.8z"/>
          <path
            d="M25.9,2.3h-2.9c-6.4,0.6-11.3,5.3-11.4,11h25.6C37.2,7.5,32.3,2.9,25.9,2.3z M20.4,8.5 c0,0.7-0.6,1.3-1.4,1.3c-0.8,0-1.4-0.6-1.4-1.3v0c0-0.7,0.6-1.3,1.4-1.3C19.8,7.2,20.4,7.8,20.4,8.5L20.4,8.5z M31.3,8.5 c0,0.7-0.6,1.3-1.4,1.3c-0.8,0-1.4-0.6-1.4-1.3v0c0-0.7,0.6-1.3,1.4-1.3C30.7,7.2,31.3,7.8,31.3,8.5L31.3,8.5z"/>
          <path d="M42.3,17.3c-1.5,0-2.7,1.2-2.7,2.7v11.7c0,1.6,1.3,2.8,2.9,2.7c1.5-0.1,2.6-1.4,2.6-2.9V20.1 C45,18.6,43.8,17.3,42.3,17.3z"/>
        </g>
      </g>
    </g>
  ]
  getViewBox = () => '0 0 48 48'
}
